import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import * as moment from 'moment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
    selector: 'app-batch-freeze',
    templateUrl: './batch-freeze.component.html',
    styleUrls: ['./batch-freeze.component.scss']
})
export class BatchFreezeComponent implements OnInit {
    BatchFreezeForm: FormGroup;
    sessionList: any[];
    SessionFilterList: any[];
    userPermission: any;
    Table = false;
    UpdateBtn = false;
    FreezeBtn = false;
    isBranch = false;
    filteredListBranch: any[];
    filteredsubjectList: any[];
    filteredListExam: any[];
    collegeList: any;
    filteredCollegeList: any;
    closeMessage: string;
    message: string;
    HeadList: any;
    examList: any[];
    CourseList: any;
    filteredListCourse: any;
    subjectList = [];
    emid: number;
    dialogRef: MatDialogRef<any>;
    BranchList: any;
    filteredListHead: any[];
    headcode: any;
    pracEsId: any;
    assignTableData: any[];
    StuArray: FormArray;
    currentDate: Date;
    updateDisable: boolean;
    utp: string;
    formativeASSCreate = true;
    formativeASSUpdate = true;
    setIntervalSearch: any;
    subcode: string;
    isFreezed: boolean = false;
    batchList: any[] = [];
    filteredBatchList: any[] = [];

    constructor(
        private spinner: NgxSpinnerService,
        public umsService: UmsService,
        private fb: FormBuilder,
        private modalPopupService: ModalpopService
    ) { }

    ngOnInit(): void {
        this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.isBranch = false;
        this.updateDisable = false;

        this.BatchFreezeForm = this.fb.group({
            college: new FormControl('', Validators.required),
            course: new FormControl('', Validators.required),
            SessionId: new FormControl('', Validators.required),
            EmId: new FormControl('', Validators.required),
            SubCode: new FormControl(''),
            EsId: new FormControl('', Validators.required),
            Branch: new FormControl(''),
            EsParentId: new FormControl('', Validators.required),
            StuArray: new FormArray([]),
            SearchString: new FormControl(''),
        });

        this.utp = sessionStorage.getItem('usertypeee');
        if (this.utp !== 'Super Admin') {
            this.userPermission.forEach(element => {
                if (element.PageName == 'Batch Freeze' && element.PCreate == false) {
                    this.formativeASSCreate = false;
                }
                if (element.PageName == 'Batch Freeze' && element.PUpdate == false) {
                    this.formativeASSUpdate = false;
                }
            });
        }
        this.fetchSession();
        this.currentDate = new Date();
    }

    getStuArrayControls() {
        return (this.BatchFreezeForm.get('StuArray') as FormArray).controls;
    }

    fetchSession() {
        this.spinner.show();
        const payload = { SnDefault: '', SnNo: '' };
        this.umsService.getSession(payload).subscribe(res => {
            this.spinner.hide();
            this.sessionList = [];
            if (res.status) {
                res.data.forEach(element => {
                    if (element.SnStatus == 'O') {
                        this.sessionList.push(element);
                    }
                });
                this.SessionFilterList = this.sessionList.slice();
            }
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.sessionList = [];
        });
    }

    getCourse(data) {
        this.spinner.show();
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.isBranch = false;
        this.filteredListExam = [];
        this.filteredListBranch = [];
        this.filteredsubjectList = [];

        const payload = { SessionId: data };
        this.umsService.getCourse(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status) {
                this.CourseList = res.data;
                this.filteredListCourse = this.CourseList.slice();
            } else {
                this.CourseList = [];
                this.filteredListCourse = [];
            }
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.CourseList = [];
        });
    }

    getCollege(item) {
        this.getExamList(item);
        this.spinner.show();
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.filteredsubjectList = [];
        this.filteredListExam = [];

        const payload = { CoCode: item.CoCode };
        this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
            this.spinner.hide();
            this.collegeList = res.data;
            this.filteredCollegeList = this.collegeList.slice();
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.collegeList = [];
        });
    }

    getExamList(item) {
        this.spinner.show();
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.filteredsubjectList = [];
        this.isBranch = false;

        const payload = { EmCoCode: item.CoCode };
        this.umsService.getExam(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status) {
                this.examList = res.data;
                this.filteredListExam = this.examList.slice();
            } else {
                let data = {
                    message: res.message,
                    title: 'Alert',
                    icon: 'fas fa-close'
                };
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            let data = {
                message: ERROR.error.message,
                title: 'Alert',
                icon: 'fas fa-close'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        });
    }

    getSubject(e) {
        this.spinner.show();
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.isBranch = false;
        this.BranchList = [];
        this.subjectList = [];
        this.filteredsubjectList = [];
        this.emid = e.EmId;

        if (e.EmStreams == "Y") {
            this.spinner.hide();
            this.isBranch = true;
            this.fetchBranch(e.EmId);
        } else {
            this.isBranch = false;
            const payload = { EsEmId: e.EmId, EsStrId: 0 };
            this.umsService.getExamSubMapFetch(payload).subscribe(res => {
                this.spinner.hide();
                res.data.children.forEach(element => {
                    if (element.EsType == 'S') {
                        this.subjectList.push(element);
                    } else if (element.EsType == 'G') {
                        element.children.forEach(grpSub => {
                            this.subjectList.push(grpSub);
                        });
                    }
                });
                this.filteredsubjectList = this.subjectList.slice();
            });
        }
    }

    fetchBranch(id) {
        this.spinner.show();
        const payload = { EmId: id };
        this.umsService.getExamStream(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status) {
                this.BranchList = res.data;
                this.filteredListBranch = this.BranchList.slice();
            }
        });
    }

    getStr(e) {
        this.spinner.show();
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.filteredsubjectList = [];
        this.subjectList = [];

        let payload = {
            EsEmId: this.emid,
            EsStrId: this.BatchFreezeForm.value.Branch
        };

        this.umsService.getExamSubMapFetch(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status) {
                res.data.children.forEach(element => {
                    if (element.EsType == 'S') {
                        this.subjectList.push(element);
                    } else if (element.EsType == 'G') {
                        element.children.forEach(grpSub => {
                            this.subjectList.push(grpSub);
                        });
                    }
                });
                this.filteredsubjectList = this.subjectList.slice();
            } else {
                this.subjectList = [];
                this.filteredsubjectList = [];
            }
        }, (ERROR: HttpErrorResponse) => {
            this.subjectList = [];
            this.filteredsubjectList = [];
        });
    }

    subjectClick(data) {
        this.spinner.show();
        this.HeadList = [];
        this.filteredListHead = [];
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.subcode = data.EsCode;

        let payload2 = this.BatchFreezeForm.value;
        const payload = {
            PtSnNo: payload2.SessionId,
            PtCoCode: payload2.course,
            PtEsCode: this.subcode,
            PtEmId: payload2.EmId,
            PtCgCode: payload2.college,
            PtStrId: payload2.Branch ? payload2.Branch : "0"
        };

        this.umsService.getPracticalBatches(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status) {
                this.HeadList = res.data;
                this.filteredListHead = this.HeadList.slice();

                // Store all batches for dropdown
                this.batchList = this.HeadList.map(item => ({
                    PbdBatchNo: item.PbdBatchNo,
                    PbdBatchName: item.PbdBatchName
                }));
                this.filteredBatchList = this.batchList.slice();
            } else {
                let data = {
                    message: 'No Batches Found',
                    title: 'Alert',
                    icon: 'fas fa-close'
                };
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.HeadList = [];
                this.BatchFreezeForm.controls['EsId'].setValue('');
            }
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            let data = {
                message: 'No Batches Found',
                title: 'Alert',
                icon: 'fas fa-close'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.HeadList = [];
            this.BatchFreezeForm.controls['EsId'].setValue('');
        });
    }

    getAllBatches() {
        // Batches already loaded from subjectClick, just show table
        this.ShowTable();
    }

    getHeadCode(data) {
        this.headcode = data.PbdBatchName;
        this.pracEsId = data.PtEsId;
        this.Table = false;
        this.UpdateBtn = false;
        this.FreezeBtn = false;
        this.getAllBatches();
    }

    ShowTable() {
        this.spinner.show();
        this.Table = false;
        let payload2 = this.BatchFreezeForm.value;
        this.StuArray = this.BatchFreezeForm.get('StuArray') as FormArray;
        this.StuArray.clear();
        this.assignTableData = [];

        const payload = {
            PtSnNo: payload2.SessionId,
            PtCoCode: payload2.course,
            PtEsId: this.pracEsId,
            PbdBatchNo: this.headcode,
            PtCgCode: payload2.college,
            PtEmId: payload2.EmId,
            PtStrId: payload2.Branch ? payload2.Branch : "0"
        };

        this.umsService.getBatchFreezeList(payload).subscribe((res) => {
            this.spinner.hide();
            if (res.status) {
                this.assignTableData = res.data;
                this.Table = true;

                if (this.assignTableData.length > 0) {
                    this.isFreezed = this.assignTableData[0].IsFreezed === 'Y';
                    this.UpdateBtn = !this.isFreezed;
                    this.FreezeBtn = true;
                }

                // batchList already populated from subjectClick via getPracticalBatches API

                this.assignTableData.forEach((element) => {
                    const creds = this.BatchFreezeForm.get('StuArray') as FormArray;
                    creds.push(
                        this.fb.group({
                            PsbaId: new FormControl(element.PsbaId),
                            PsbaPtId: new FormControl(element.PsbaPtId),
                            PsbaStuId: new FormControl(element.PsbaStuId),
                            Name: new FormControl(element.StuFirstNameEng),
                            StuRgNo: new FormControl(element.StuRgNo),
                            OldBatchNo: new FormControl(element.PsbaBatchNo),
                            NewBatchNo: new FormControl(element.PsbaBatchNo),
                            PtId: new FormControl(element.PtId)
                        })
                    );
                });

                this.getSessionCutOff();
            } else {
                this.assignTableData = [];
                this.UpdateBtn = false;
                this.FreezeBtn = false;
                let data = {
                    message: 'No Data Found',
                    title: 'Alert',
                    icon: 'fas fa-close'
                };
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.getSessionCutOff();
            }
        }, (ERROR: HttpErrorResponse) => {
            this.getSessionCutOff();
            this.spinner.hide();
            this.assignTableData = [];
            this.UpdateBtn = false;
            this.FreezeBtn = false;
            let data = {
                message: ERROR.error.message,
                title: 'Alert',
                icon: 'fas fa-close'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        });
    }

    getSessionCutOff() {
        this.spinner.show();
        let payload2 = this.BatchFreezeForm.value;
        const payload = {
            SessionID: payload2.SessionId,
            CoCgCgCode: payload2.college,
            CoCgCoCode: payload2.course,
            InCode: 'PrBat',
            EmId: payload2.EmId
        };

        this.umsService.findSessionCutOff(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status) {
                const data = res.data[res.data.length - 1];
                if (data && data.CutOffDateFrom && data.CutOffDate) {
                    const toDateOnly = (date: Date): Date => {
                        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    };

                    const cutOffDateFrom = new Date(data.CutOffDateFrom);
                    const cutOffDate = new Date(data.CutOffDate);
                    const currentDate = new Date();
                    const startDate = toDateOnly(cutOffDateFrom);
                    const endDate = toDateOnly(cutOffDate);
                    const today = toDateOnly(currentDate);

                    if (today >= startDate && today <= endDate) {
                        this.message = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')}`;
                    } else {
                        this.closeMessage = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')} now session is closed`;
                    }
                }
            } else {
                this.closeMessage = 'The session cutoff has not been added.';
            }
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.closeMessage = 'The session cutoff has not been added.';
        });
    }

    update() {
        this.spinner.show();
        const submitpayload = this.BatchFreezeForm.value;
        this.StuArray = this.BatchFreezeForm.get('StuArray') as FormArray;
        const students = this.StuArray.value;

        const batchUpdates = students.map(student => ({
            PsbaId: student.PsbaId,
            OldBatchNo: student.OldBatchNo,
            NewBatchNo: student.NewBatchNo,
            PtId: student.PtId
        }));

        const payloadData = {
            BatchUpdates: JSON.stringify(batchUpdates),
            LoginId: parseInt(sessionStorage.getItem('userId'))
        };

        this.umsService.updateBatchAllocations(payloadData).subscribe(res => {
            this.spinner.hide();
            if (res.status) {
                let data = {
                    message: res.message || "Updated Successfully",
                    title: 'Information',
                    icon: 'fas fa-check'
                };
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.dialogRef.afterClosed().subscribe(() => {
                    this.ShowTable();
                });
            } else {
                let data = {
                    message: res.message || 'Update failed',
                    title: 'Alert',
                    icon: 'fas fa-close'
                };
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            let data = {
                message: ERROR.error.message,
                title: 'Alert',
                icon: 'fas fa-close'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        });
    }

    freezeBatches() {
        const freezeStatus = this.isFreezed ? 'N' : 'Y';
        const freezeMessage = this.isFreezed
            ? "Are you sure you want to UNFREEZE batches? Teachers will be able to make changes again."
            : "Are you sure you want to FREEZE batches? No further changes will be allowed.";

        const data: any = {
            message: freezeMessage,
            title: "Confirm",
            icon: "fa fa-question",
        };

        this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
            if (result === "yes") {
                this.submitFreeze(freezeStatus);
            }
        });
    }

    submitFreeze(freezeStatus: string) {
        const submitpayload = this.BatchFreezeForm.value;
        const payload: any = {
            PtSnNo: submitpayload.SessionId,
            PtCoCode: submitpayload.course,
            PtCgCode: submitpayload.college,
            PtEmId: submitpayload.EmId,
            PtEsId: this.pracEsId,
            PtStrId: submitpayload.Branch ? submitpayload.Branch : 0,
            FreezStatus: freezeStatus,
            LoginId: parseInt(sessionStorage.getItem('userId'))
        };

        this.spinner.show();
        this.umsService.freezeBatchAllocations(payload).subscribe((res) => {
            this.spinner.hide();
            if (res.status) {
                const data = {
                    message: res.message || "Operation Successful",
                    title: "Information",
                    icon: "fas fa-check",
                };
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.dialogRef.afterClosed().subscribe(() => {
                    this.ShowTable();
                });
            } else {
                this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                    message: res.message || "Operation failed.",
                    title: "Error",
                    icon: "fas fa-times",
                });
            }
        }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                message: ERROR.error.message || "Operation failed.",
                title: "Error",
                icon: "fas fa-times",
            });
        });
    }

    onBatchChange(index: number, newBatchNo: number) {
        const stuArray = this.BatchFreezeForm.get('StuArray') as FormArray;
        const studentGroup = stuArray.at(index) as FormGroup;
        studentGroup.patchValue({ NewBatchNo: newBatchNo });
    }

    keypress() {
        this.spinner.show();
        if (this.setIntervalSearch) {
            clearTimeout(this.setIntervalSearch);
        }
        this.setIntervalSearch = setTimeout(() => {
            this.ShowTable();
        }, 1000);
    }
}